import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from '../IconBase';
var Svg24X24HamburgerOutline = function Svg24X24HamburgerOutline(props) {
  return /*#__PURE__*/React.createElement(IconBase, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 5h16a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2m0 12h16a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2m0-6h16a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2",
    clipRule: "evenodd"
  })));
};
export default Svg24X24HamburgerOutline;